import React from 'react'
import TradeTabForm from "./TradeTabForm";

export default function TradeTabBuy({aft_data, balance_data, is_reloaded, reloadPage}) {
    return (
        <TradeTabForm type={"buy"} aft_data={aft_data} balance_data={balance_data} reloadPage={reloadPage}
                      is_reloaded={is_reloaded}/>
    )
}